import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Icon, Input } from 'antd';
const FormItem = Form.Item;

export class InputItem extends Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    status: PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    isValid: PropTypes.func,
    icon: PropTypes.string,
    placeholder: PropTypes.string,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    checkOnChange: PropTypes.bool,
    showWarning: PropTypes.bool,
    checkOnBlur: PropTypes.bool,
    notEmpty: PropTypes.bool,
    onBlur: PropTypes.func,
    type: PropTypes.string,
    onCheck: PropTypes.func,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    checkOnChange: false,
    disabled: false,
    checkOnBlur: true,
    showError: true,
    showSuccess: true,
    required: false,
    type: 'text'
  };

  constructor(props) {
    super(props)
    this.state = {
        status: '',
        help: this.props.status.help || ''
    }
  }

  componentWillReceiveProps(props){
    if(props.setStatus)
      this.setState({
        status: props.setStatus
      })
  }

  onChange = (event) => {
    if(this.props.onChange)
      this.props.onChange(event.target.value);

    if(this.props.checkOnChange)
      this.check(event.target.value)
  }

  onBlur = (event) => {
    if(this.props.onBlur)
      this.props.onBlur(event.target.value);

    if(this.props.checkOnBlur)
      this.check(event.target.value)
  }

  check = (value) => {
    let status = null;

    if(this.props.isValid && this.props.isValid(value) && this.props.showSuccess){
      status = 'success'
    }
    else if (value && this.props.showError){
      status = 'error'
    }
    else if (this.props.required) {
      status = 'warning'
    } 
    else {
      status = '';
    }

    if(this.props.onCheck)
      this.props.onCheck(status === 'success' || status === '')

    this.setState({
      status,
      help: this.props.status[status] || ''
    })
  }

  render() {
    return (
        <FormItem
            hasFeedback
            validateStatus={ this.state.status }
            help={ this.state.help }>
            <Input
            value={ this.props.value } 
            onChange={this.onChange}
            onBlur={this.onBlur}
            disabled={this.props.disabled}
            prefix={<Icon type={ this.props.icon } style={{ color: 'rgba(0,0,0,.25)' }} />} type={ this.props.type || 'text' } placeholder={ this.props.placeholder } />
        </FormItem>
    );
  }
}

export default InputItem;



// WEBPACK FOOTER //
// ./src/helper/form/input/item.js